import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import ROUTES from 'utils/ROUTES'
import MAINTENANCE_TYPE from 'utils/__enums/SuperAdministration/Maintenance'

interface Props {
  children: React.ReactNode
}

const InscriptionPagesGuard: React.FC<Props> = ({ children }: Props) => {
  const history = useHistory()

  const CREATE_USER_DISABLED =
    !process?.env?.REACT_APP_CREATE_USER_ENABLED ||
    localStorage.getItem(`maintenanceMode${MAINTENANCE_TYPE.CREATE_USERS}`) ===
      'true'

  useEffect(() => {
    if (CREATE_USER_DISABLED) history.push(ROUTES.Home)
  }, [])

  return <> {children} </>
}

export default InscriptionPagesGuard
